// import {Controller} from 'react-hook-form';

import Typography from 'components/Typography';
import PageHeader from 'components/PageHeader';
import Button from 'components/Button';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
// import SelectField from 'components/SelectField';
import ListWrapper from 'components/ListWrapper';
import Pagination from 'components/Pagination';
import './Style.scss';
// import states from 'constants/states';
import {validateEmail} from 'utils/validators';
import syncIcon from './sync.svg';
import shareIcon from './share.svg';
import useUserForm from './useUserForm';
import UserAddresses from './UserAddresses';
import CardInformation from './CardInformation/CardInformation';
import DataTable from 'components/DataTable';
import {DataTableSchemaItem, ScriptStatus} from 'types';
import {Key, useMemo, useRef} from 'react';
import ListTabs from './ListTabs';
import {get} from 'lodash';
import Modal from 'components/Modal';
import styles from './UserForm.module.scss';
import Select from 'components/Select';
import {formatDateString} from 'pages/PrescriberUsers/Users';
import {phoneFormat} from 'helpers/phoneFormat';
import ScriptStatusSelect from 'components/ScriptStatusSelect';
import DateTimePicker from 'components/DateTimePicker';
import {components} from 'react-select';
import {addressToString} from 'helpers/address';
import ArrowIcon from './UserAddresses/ArrowIcon';
import {Controller} from 'react-hook-form';
import {GooglePlaceAutoComplete} from 'components/GooglePlaceAutoComplete';
import MapPreview from 'components/MapPreview';
import CheckIcon from 'pages/Settings/Users/CheckIcon';
// import Spinner from 'components/Spinner';

// import styles from "./UserForm.module.scss";

const REQUESTS_SCHEMA: DataTableSchemaItem[] = [
  {dataKey: 'number', header: 'Request #', sortable: false},
  {dataKey: 'rx_no', header: 'Rx #', sortable: false},
  {dataKey: 'sync_time', header: 'Sync Time', sortable: true},
  {dataKey: 'customer', header: 'Patient', sortable: true},
  {dataKey: 'status', header: 'Status', sortable: true},
  {dataKey: 'drug_name', header: 'Drug name', sortable: false},
  // {dataKey: 'refill_no', header: 'Refill #', sortable: false},
];

const MM_SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'transaction_id',
    header: 'ID',
    sortable: false,
    index: 0,
  },
  {dataKey: 'amount', header: 'Amount', sortable: true, index: 1},
  {
    dataKey: 'transaction_date',
    header: 'Date',
    sortable: true,
    align: 'center',
    index: 2,
  },
  {
    dataKey: 'transaction_origin',
    header: 'Source',
    align: 'center',
    sortable: false,
    index: 3,
  },
  {dataKey: 'list_rx', header: 'List of RXs', sortable: false, index: 5},
  {dataKey: 'list_orders', header: 'List of Orders', sortable: false, index: 6},
  {dataKey: 'card_type', header: 'Card Type', sortable: true, index: 4},
];

function UserForm() {
  const {
    userId,
    addresses,
    setAddressesForUpdate,
    submitting,
    errors,
    register,
    handleSubmit,
    requests,
    orders,
    transactions,
    // isLoading,
    sortBy,
    sortOrder,
    onSort,
    requestsLoading,
    orderLoading,
    transactionsLoading,
    refetch,
    totalPages,
    currentPage,
    pageSize,
    count,
    setCurrentPage,
    setPageSize,
    status,
    setStatus,
    cards,
    filledOrders,
    isPrescriber,
    copayItems,
    submitSelectedCard,
    onCharge,
    accessCardModal,
    setAccessCardModal,
    selectCardModal,
    setSelectCardModal,
    addressModalVisible,
    setAddressModalVisible,
    cardId,
    setCardIs,
    sendAppLink,
    syncHandler,
    handleNavigateTransaction,
    handleNavigateRequest,
    handleNavigateOrders,
    canWrite,
    customer,
    selectedOrders,
    showStatusModal,
    setShowStatusModal,
    onChangeStatus,
    data,
    setData,
    deliveryAddressId,
    setDeliveryAddressId,
    openAddressModal,
    setOpenAddressModal,
    addressControl,
    setAddressValee,
    handleAddressSubmit,
    onSelectPlace,
    locationPreview,
    handleAddressCreation,
    push,
    orderStatus,
    submitOrderStatutes,
    setCopayItems,
    allSelected,
    setAllSelected,
    isCharging,
  } = useUserForm();
  const SCHEMA: DataTableSchemaItem[] = [
    {
      dataKey: 'checkbox',
      header: '',
      sortable: false,
      colWidth: '80px',
    },
    {dataKey: 'number', header: 'Order #', sortable: false},
    {dataKey: 'rx_no', header: 'Rx #', sortable: false},
    {dataKey: 'sync_time', header: 'Sync Time', sortable: true},
    {dataKey: 'bill_date', header: 'Bill Time'},
    {dataKey: 'is_paid', header: 'Paid', sortable: true},
    {dataKey: 'status', header: 'Status', sortable: true},
    // {dataKey: 'refill_no', header: 'Refill #', sortable: false},
    // {dataKey: 'view', header: '', align: 'right'},
    {dataKey: 'drug_name', header: 'Drug Name', sortable: false},
    {
      dataKey: 'preference_date',
      header: 'Preference Date',
      sortable: false,
      colWidth: '190px',
    },
  ];

  const isDetails = useRef(true);

  const tabs = useMemo(function () {
    return [
      {title: 'Details', value: ''},
      {title: 'Addresses', value: 'address'},
      {title: 'Cards', value: 'cards'},
      {title: 'Orders', value: 'orders'},
      {title: 'Requests', value: 'requests'},
      {title: 'Transactions', value: 'transactions'},
    ];
  }, []);

  const COPAY_SCHEMA: DataTableSchemaItem[] = useMemo(() => {
    return [
      {
        dataKey: 'checkbox',
        header:
          copayItems.length > 0 ? (
            <div
              onClick={(val) => {
                val.stopPropagation();
              }}
              className={styles.selectAll}
            >
              <div
                onClick={(val) => {
                  setAllSelected(false);
                  setCopayItems([]);
                }}
                className={styles.selectAllIcon}
              >
                <CheckIcon emptySelect={false} allSelected={allSelected} />
              </div>
              <Select
                components={{
                  Input: () => null,
                  ValueContainer: () => null,
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: 'none',
                    backgroundColor: 'transparent',
                  }),
                  container: (base) => ({
                    ...base,
                    width: 70,
                  }),
                }}
                options={[
                  {label: 'All', value: 'all'},
                  {label: 'None', value: 'none'},
                ]}
                onChange={(val) => {
                  if (val?.value === 'all') {
                    setCopayItems(
                      filledOrders?.map((item) => ({
                        id: (item as any).prescription_id,

                        amount_due: item.amount_due,
                      }))
                    );
                    setAllSelected(true);
                  } else {
                    setCopayItems([]);
                    setAllSelected(false);
                  }
                }}
              />
            </div>
          ) : (
            <div style={{height: 40}}></div>
          ),
        sortable: false,
        colWidth: '40px',
      },
      {dataKey: 'rx_no', header: 'Rx #', sortable: false},
      {dataKey: 'drug_name', header: 'Drug name', sortable: false},
      {
        dataKey: 'status',
        header: 'Status',
        sortable: false,
        align: 'center',
      },

      {
        dataKey: 'amount_due',
        header: 'Amount due',
        sortable: false,
        align: 'center',
      },
      {
        dataKey: 'bill_time',
        header: 'Bill time',
        sortable: false,
      },
    ];
  }, [
    allSelected,
    copayItems.length,
    filledOrders,
    setAllSelected,
    setCopayItems,
  ]);
  const isCopayChargeDisabled = !cardId?.value || copayItems.length === 0;
  const selectedCard = useMemo(() => {
    return cards.find((item: any) => item.custom_uuid === cardId?.value);
  }, [cards, cardId]);
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <PageHeader>
          {isPrescriber ? (
            <Typography variant="h2">Patient Orders</Typography>
          ) : (
            <>
              <Typography variant="h2">
                {userId
                  ? `Edit Patient: ${get(
                      customer,
                      'user.first_name',
                      ''
                    )} ${get(customer, 'user.last_name', '')}`
                  : 'New Patient'}
              </Typography>

              {status === 'orders' && (
                <div style={{display: 'flex', gap: 10}}>
                  {selectedOrders.length > 0 && (
                    <Button
                      onClick={() => setShowStatusModal(true)}
                      color="blue"
                    >
                      Bulk Update
                    </Button>
                  )}
                  <Button onClick={syncHandler} color="blue">
                    Sync Patient Profile
                    <img alt="sync" style={{marginLeft: 10}} src={syncIcon} />
                  </Button>
                  <Button onClick={onCharge} color="green">
                    Charge All
                  </Button>
                </div>
              )}
            </>
          )}
        </PageHeader>
        {!isPrescriber && (
          <>
            <ListTabs
              tab="user_tab"
              onChange={setStatus}
              activeTabValue={status}
              tabs={tabs}
            />

            <FormGroup style={{marginBottom: 20}} columns={2}>
              {status === '' && (
                <ListWrapper className={styles.listWrapper}>
                  <div>
                    <div className={styles.flex}>
                      <Typography variant="h3">Details</Typography>
                      <Button onClick={sendAppLink} color="green">
                        Send App Link
                        <img
                          alt="sync"
                          style={{marginLeft: 10}}
                          src={shareIcon}
                        />
                      </Button>
                    </div>
                    <FormGroup columns={2}>
                      <TextField
                        label="First Name"
                        placeholder="First Name"
                        {...register('first_name', {required: 'Required'})}
                        error={errors.first_name?.message}
                      />
                      <TextField
                        label="Last Name"
                        placeholder="Last Name"
                        {...register('last_name', {required: 'Required'})}
                        error={errors.last_name?.message}
                      />
                    </FormGroup>

                    <FormGroup columns={1}>
                      <TextField
                        label="Email Address"
                        placeholder="Email Address"
                        {...register('email', {
                          required: 'Required',
                          validate: validateEmail,
                        })}
                        error={errors.email?.message}
                      />
                    </FormGroup>

                    <FormGroup columns={1}>
                      <TextField
                        label="Phone 1 (main)"
                        placeholder="(123) 456-7890"
                        {...register('phone', {
                          required: 'Required',
                          minLength: {
                            value: 14,
                            message: 'Phone number length must be 14',
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = phoneFormat(e.target.value);
                        }}
                        error={errors.phone?.message}
                      />
                    </FormGroup>
                    <FormGroup columns={1}>
                      <TextField
                        label="Phone 2"
                        placeholder="(123) 456-7890"
                        {...register('phone_2', {
                          minLength: {
                            value: 14,
                            message: 'Phone number length must be 14',
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = phoneFormat(e.target.value);
                        }}
                        error={errors.phone_2?.message}
                      />
                    </FormGroup>
                    <FormGroup columns={1}>
                      <TextField
                        label="Phone 3"
                        placeholder="(123) 456-7890"
                        {...register('phone_3', {
                          minLength: {
                            value: 14,
                            message: 'Phone number length must be 14',
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = phoneFormat(e.target.value);
                        }}
                        error={errors.phone_3?.message}
                      />
                    </FormGroup>

                    <FormGroup columns={1}>
                      <TextField
                        label="Date of Birth"
                        placeholder="mm/dd/yyyy"
                        {...register('birthday', {
                          required: 'Required',
                        })}
                        onChange={(e) => {
                          const formattedDate = formatDateString(
                            e.target.value
                          );
                          e.target.value = formattedDate;
                        }}
                        error={errors.birthday?.message}
                      />
                    </FormGroup>
                    <FormGroup columns={1}>
                      <p style={{marginBottom: 0}}>Allergies</p>
                      <textarea
                        className={styles.noteInput}
                        {...register('allergies')}
                      />
                    </FormGroup>
                  </div>
                  {canWrite && (
                    <Button
                      className={styles.save}
                      type="submit"
                      onClick={() => {
                        isDetails.current = true;
                      }}
                      color="green"
                      loading={isDetails.current && submitting}
                    >
                      Save details
                    </Button>
                  )}
                </ListWrapper>
              )}
              {status === 'cards' && (
                <ListWrapper style={{padding: 0}}>
                  <CardInformation
                    setAddressModalVisible={setAddressModalVisible}
                    addresses={addresses}
                    userId={userId}
                  />
                </ListWrapper>
              )}

              <UserAddresses
                addressModalVisible={addressModalVisible}
                setAddressModalVisible={setAddressModalVisible}
                addresses={addresses}
                userId={Number(userId)}
                onSave={() => {
                  isDetails.current = false;
                }}
                refetch={refetch}
                isShow={status === 'address'}
                deleting={!isDetails.current && submitting}
                onChange={setAddressesForUpdate}
              />
            </FormGroup>
          </>
        )}
      </form>

      {(status === 'orders' || isPrescriber) && (
        <DataTable
          schema={SCHEMA}
          data={orders}
          // sortBy={sortBy}
          // sortOrder={sortOrder}
          onClick={handleNavigateOrders}
          // onSort={onSort}
          loading={orderLoading}
        />
      )}
      {status === 'requests' && (
        <DataTable
          schema={REQUESTS_SCHEMA}
          data={requests}
          // sortBy={sortBy}
          // sortOrder={sortOrder}
          onClick={handleNavigateRequest}
          // onSort={onSort}
          loading={requestsLoading}
        />
      )}
      {status === 'transactions' && (
        <DataTable
          schema={MM_SCHEMA}
          data={transactions}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleNavigateTransaction}
          onSort={onSort}
          loading={transactionsLoading}
        />
      )}
      {(status === 'transactions' || status === 'orders') && totalPages > 1 && (
        <Pagination
          page={currentPage}
          total={totalPages}
          count={count || 0}
          pageSize={pageSize}
          setCurrentPage={setCurrentPage}
          setPageSize={setPageSize}
        />
      )}
      <Modal
        isOpen={selectCardModal}
        onClose={() => setSelectCardModal(false)}
        className={styles.list_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Select Card to Charge:
        </Typography>
        <div className={styles.optionWrapper}>
          {cards.map((item: any, index: Key | null | undefined) => {
            return (
              <label key={index} className={styles.radioOption}>
                <input
                  type="radio"
                  name="radio"
                  defaultChecked={cardId === item.custom_uuid}
                  onClick={() => setCardIs(item.custom_uuid)}
                />
                {/* <div className={styles.column}> */}
                <span className={styles.radioButtonText}>
                  {get(item, 'cardholder_name', '')}
                </span>
                <p
                  style={{marginLeft: 'auto'}}
                  className={styles.radioButtonText}
                >
                  **** **** **** {get(item, 'last4', '')}
                </p>
                {/* </div> */}
              </label>
            );
          })}
        </div>
        <div className={styles.actions}>
          <Button
            color="green"
            onClick={() => setAccessCardModal(true)}
            size="md"
          >
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={accessCardModal}
        onClose={() => setAccessCardModal(false)}
        className={styles.orders_wrapper}
      >
        <Typography component="p" className={styles.modalDesc} variant="h2">
          Are you sure you want to charge?
        </Typography>
        <Typography
          component="p"
          style={{marginTop: 25, marginBottom: 10}}
          variant="h4"
        >
          Card:
        </Typography>
        <Select
          className={styles.selectCon}
          isSearchable={false}
          onChange={(val: any) => setCardIs(val)}
          options={cards.map((item) => ({
            value: item.custom_uuid,
            label: `**** **** **** ${get(item, 'last4', '')} - ${
              item.cardholder_name
            }`,
          }))}
          value={cardId}
          placeholder={
            <span className="select-placeholder-text">Select card</span>
          }
        />

        {/* <div className={styles.card}>
          <div className={styles.item_header}>
            <div>{get(selectedCard, 'cardholder_name', '')}</div>
          </div>
          <div className={styles.row}>
            <div>**** **** **** {get(selectedCard, 'last4', '')}</div>
            <div>
              Expiration: {get(selectedCard, 'exp_month', '')}/
              {get(selectedCard, 'exp_year', '')}
            </div>
          </div>
        </div> */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 30,
            marginTop: 30,
          }}
        >
          <Typography component="p" style={{marginTop: 25}} variant="h4">
            Orders:
          </Typography>
          <Typography component="p" style={{marginTop: 25}} variant="h4">
            Total: $
            {copayItems
              .reduce(
                (pr: number, curr: any) => pr + Number(curr.amount_due),
                0
              )
              .toFixed(2)}
          </Typography>
        </div>

        <DataTable
          containerStyle={styles.orders}
          wrapperStyle={styles.ordersWrapper}
          schema={COPAY_SCHEMA}
          data={filledOrders.map((item) => ({
            ...item,
            amount_due: '$' + Number(item.amount_due).toFixed(2),
          }))}
          onClick={(row) => {
            push(`/orders/${row.id}`);
          }}
        />
        <div className={styles.actions}>
          <Button
            type="submit"
            color={isCopayChargeDisabled ? 'gray' : 'green'}
            disabled={isCopayChargeDisabled || isCharging}
            loading={isCharging}
            onClick={submitSelectedCard}
            size="md"
          >
            Charge - {get(selectedCard, 'last4', '')}
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={showStatusModal}
        onClose={() => setShowStatusModal(false)}
        className={styles.status_wrapper}
      >
        <Typography variant="h2">Bulk Update</Typography>
        <div className={styles.times}>
          <div style={{flex: 1}}>
            <div className={styles.label}>Status:</div>
            <ScriptStatusSelect
              name={`status`}
              status={orderStatus as ScriptStatus}
              onChange={onChangeStatus}
              type="prescription"
              origin={'micromerchant'}
              isPvfr={true}
              isVerified={true}
              menuPosition="fixed"
              classNamePrefix={'order_select'}
              className={orderStatus || 'default_selected'}
            />
          </div>
          <div style={{flex: 1}}>
            <div className={styles.label}>Preference date:</div>
            <div className={styles.calendarRoot}>
              <DateTimePicker
                showTimeSelect={false}
                dateFormat="MM/dd/yy E"
                value={data.preference_date ? data.preference_date : undefined}
                onChange={(date) => {
                  setData((pr) => ({
                    ...pr,
                    preference_date: date ? date : null,
                  }));
                }}
              />
            </div>
          </div>
          <div style={{flex: 1}}>
            <div className={styles.label}>Preference time:</div>
            <Select
              className={styles.select}
              onChange={(time) => {
                setData((pr) => ({
                  ...pr,
                  preference_time: String(time?.value || ''),
                }));
              }}
              placeholder={
                <span className="select-placeholder-text">Select time</span>
              }
              isClearable
              components={{
                DropdownIndicator: (props) =>
                  !data.preference_time ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
              }}
              value={
                data.preference_time
                  ? {
                      value: data.preference_time,
                      label:
                        data.preference_time[0].toUpperCase() +
                        data.preference_time.slice(1),
                    }
                  : null
              }
              options={[
                {value: 'morning', label: 'Morning'},
                {value: 'afternoon', label: 'Afternoon'},
                {value: 'evening', label: 'Evening'},
              ]}
              size="md"
            />
          </div>
        </div>
        <div className={styles.label}> Select Delivery Address:</div>
        <div className={styles.optionWrapperAddress}>
          {addresses.map((item: any, index: Key | null | undefined) => {
            return (
              <label key={index} className={styles.containerAddress}>
                <input
                  type="radio"
                  name="radio"
                  defaultChecked={deliveryAddressId === item.id}
                  onClick={() => setDeliveryAddressId(item.id)}
                />
                <span className={styles.radioButtonText}>
                  {addressToString(item)}
                </span>
                {!get(item, 'is_valid', true) && (
                  <span className={styles.wrongAddress}>issue</span>
                )}
              </label>
            );
          })}
          <div
            onClick={() => setOpenAddressModal((pr) => !pr)}
            className={styles.addAddress}
          >
            <p>+ Add address</p>
            <ArrowIcon
              className={
                openAddressModal ? styles.icon_rotated : styles.arror_icon
              }
            />
          </div>
          {openAddressModal && (
            <ListWrapper
              style={{
                marginTop: 10,
                paddingLeft: 20,
                paddingRight: 20,
                paddingBottom: 15,
              }}
            >
              <FormGroup>
                <Controller
                  name="city"
                  control={addressControl}
                  rules={{required: 'Please, Select the address'}}
                  render={({field, fieldState}) => (
                    <GooglePlaceAutoComplete
                      label="Your address"
                      placeholder="Address"
                      onSelectPlace={onSelectPlace}
                      error={fieldState.error?.message}
                      options={{
                        types: ['address'],
                      }}
                    />
                  )}
                />
                <Controller
                  name="unit_address"
                  control={addressControl}
                  render={({field, fieldState}) => (
                    <TextField
                      label="Unit number"
                      wrapperClass={styles.googleInput}
                      placeholder="Enter unit number"
                      hasError={false}
                      onChange={field.onChange}
                      error={fieldState.error?.message}
                    />
                  )}
                />
              </FormGroup>
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  paddingTop: 20,
                }}
              >
                {!!locationPreview.latitude && (
                  <MapPreview
                    zoom={15}
                    onDrag={(location) => {
                      setAddressValee('latitude', location.lat);
                      setAddressValee('longitude', location.lon);
                    }}
                    center={[
                      locationPreview.latitude,
                      locationPreview.longitude,
                    ]}
                  />
                )}
              </div>

              <div className={styles.actionWrapper}>
                <Button
                  type="submit"
                  onClick={handleAddressSubmit(handleAddressCreation)}
                  color="green"
                >
                  Add
                </Button>
              </div>
            </ListWrapper>
          )}
        </div>
        <div className={styles.actions}>
          <Button
            type="submit"
            color="green"
            disabled={!orderStatus || !deliveryAddressId}
            onClick={submitOrderStatutes}
            size="md"
          >
            Submit
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default UserForm;
